module.exports = __webpack_public_path__ + "img/3x.c0599bac.png";